import { render, staticRenderFns } from "./StarshipChapter.vue?vue&type=template&id=43dd8b0c&lang=pug&"
import script from "./StarshipChapter.vue?vue&type=script&lang=ts&"
export * from "./StarshipChapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports